// @flow
import React, { PureComponent } from 'react'
import utmLinkGenerator from '../../utils/UTMLinkGenerator'
import WidgetContainer from '../../containers/WidgetContainer'
import OverlayImage from '../../boxes/images/OverlayImage'
import ListBox from '../../boxes/VideoListBox'
import { type VideoWidgetProps } from './Types'
import FirstBox from './StyledFirstBox'
import ContainerRow from './StyledContainerRow'
import LeftColumn from './StyledLeftColumn'
import RightColumn from './StyledRightColumn'
import VideoImage from './StyledVideoImage'
import VideoImageWrapper from './StyledVideoImageWrapper'

export default class Video extends PureComponent<VideoWidgetProps> {
  render () {
    const {
      isOpening,
      widget,
      widget: {
        boxes = [],
        utmMedium
      }
    } = this.props

    if (!boxes.length) return null

    const videoBoxes = [...boxes]
    let featuredBox = videoBoxes.shift()
    featuredBox = {
      ...featuredBox,
      ...{ image: featuredBox.images['16_9L'] }
    }

    const featuredUtmLink = utmLinkGenerator.createLink(featuredBox.link, {
      utmMedium,
      utmTerm: `position-0`,
      utmCampaign: featuredBox.source
    })

    return (
      <WidgetContainer widget={widget} isOpening={isOpening}>
        <ContainerRow>
          <LeftColumn>
            <FirstBox href={featuredUtmLink}>
              <OverlayImage
                imageComponent={VideoImage}
                imageWrapperComponent={VideoImageWrapper}
                overlayType={featuredBox.featuredType}
                src={featuredBox.image}
                duration={featuredBox.duration}
              />
              <div>
                {featuredBox.title}
              </div>
            </FirstBox>
          </LeftColumn>
          <RightColumn>
            {
              videoBoxes.map((box, index) => {
                const {
                  featuredType,
                  guid,
                  link,
                  source,
                  title,
                  duration,
                  images: {
                    '16_9': image
                  }
                } = box

                const utmLink = utmLinkGenerator.createLink(link, {
                  utmMedium,
                  utmTerm: `position-${index + 1}`,
                  utmCampaign: source
                })

                return (
                  <ListBox
                    featuredType={featuredType}
                    key={guid}
                    link={utmLink}
                    title={title}
                    image={image}
                    duration={duration}
                  />
                )
              })
            }
          </RightColumn>
        </ContainerRow>
      </WidgetContainer>
    )
  }
}
